import React from "react";

export default function UploadIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 46}
            height={props.height || 46}
            viewBox="0 0 46 46"
            {...props}
        >
            <g
                id="Groupe_32751"
                data-name="Groupe 32751"
                transform="translate(0)"
            >
                <rect
                    id="Rectangle"
                    width="46"
                    height="46"
                    rx="6"
                    transform="translate(0)"
                    fill="#fff"
                />
                <g
                    id="_01_align_center"
                    data-name="01 align center"
                    transform="translate(12.701 9.878)"
                >
                    <path
                        id="Tracé_17814"
                        data-name="Tracé 17814"
                        d="M11.7,0a2.825,2.825,0,0,1,2,.829l3.7,3.7L16.066,5.865,12.635,2.433,12.61,17.944H10.722l.025-15.5L7.327,5.867,5.992,4.533l3.7-3.7A2.826,2.826,0,0,1,11.7,0Z"
                        transform="translate(-0.333 0)"
                        fill="#2b2828"
                    />
                    <path
                        id="Tracé_17815"
                        data-name="Tracé 17815"
                        d="M20.777,16v4.722a.944.944,0,0,1-.944.944h-17a.944.944,0,0,1-.944-.944V16H0v4.722a2.833,2.833,0,0,0,2.833,2.833h17a2.833,2.833,0,0,0,2.833-2.833V16Z"
                        transform="translate(0 -0.889)"
                        fill="#2b2828"
                    />
                </g>
            </g>
        </svg>
    );
}
